import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

const CheckBoxStyles = styled.div`
  outline: 0;

  input {
    display: none;
  }

  label {
    align-items: center;
    color: rgb(78, 82, 85);
    cursor: pointer;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-family: 'source-sans-pro', sans-serif;
  }

  label:before {
    background: ${Colors.primary.white.standard} no-repeat center;
    background-size: 70%;
    border: ${Colors.accent.grey2.standard} 1px solid;
    border-radius: 2px;
    content: 'c';
    font-size: 0;
    outline: 0;
    margin-right: 10px;
    min-height: 20px;
    min-width: 20px;
  }

  &:focus label:before {
    border-color: ${Colors.primary.claytonBlue.standard};

    &:hover {
      border-color: ${Colors.primary.claytonBlue.hover};
    }
  }

  input:checked + label:before {
    background-image: url(${require('./checkmark.svg')});
    background-color: ${Colors.primary.claytonBlue.standard};
    border-color: ${Colors.primary.claytonBlue.standard};
  }

  &:hover {
    label:before {
      border-color: ${Colors.primary.claytonBlue.standard};
    }
    input:checked + label:before {
      background-color: ${Colors.primary.claytonBlue.hover};
      border-color: ${Colors.primary.claytonBlue.hover};
    }
  }

  &.compact {
    label:before {
      height: 12px;
      width: 12px;
    }

    label {
      font-size: 12px;
    }
  }

  input:disabled {
    & + label:before,
    &:hover + label:before,
    &:focus + label:before,
    &:hover:focus + label:before {
      background-color: ${Colors.accent.grey3.standard};
      border-color: ${Colors.accent.grey3.standard};
    }

    & + label {
      cursor: not-allowed;
      color: ${Colors.accent.grey3.standard};
    }
  }

  .error-message {
    color: ${Colors.accent.ladyBug.standard};
    font-family: 'source-sans-pro', sans-serif;
    font-size: 12px;
    height: 22px;
    letter-spacing: -0.2px;
    line-height: 1.83;
    margin-top: 0;
    text-align: left;
  }
`;

export default CheckBoxStyles;
